import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "py-3 container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "space-y-4 flex flex-col justify-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-lg font-semibold" }, "Select a reason to closing this job ")
], -1)
const _hoisted_3 = { class: "flex flex-col w-full mt-4" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Select a reason ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("(Required)")
const _hoisted_6 = { class: "flex flex-col w-full mt-2 mb-2" }
const _hoisted_7 = { class: "flex flex-row justify-between items-center mt-2" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "relative flex flex-row items-center justify-center ml-4 mr-4" }, [
  /*#__PURE__*/_createElementVNode("span", null, " Confirm")
], -1)
const _hoisted_10 = [
  _hoisted_9
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_quote = _resolveComponent("quote")!
  const _component_DropDown = _resolveComponent("DropDown")!
  const _component_Divider = _resolveComponent("Divider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", null, [
        _hoisted_4,
        _createVNode(_component_quote, { class: "text-yellow-600" }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_DropDown, {
          modelValue: _ctx.reason,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.reason) = $event)),
          label: "Reason...",
          options: _ctx.closeJobReason,
          typeInput: "text",
          name: "reason"
        }, null, 8, ["modelValue", "options"])
      ]),
      _createVNode(_component_Divider, { height: "px" }),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("button", {
          class: "rounded-full border-2 border-primary text-primary py-4 px-6",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
        }, " Cancel "),
        _createElementVNode("button", {
          class: _normalizeClass(["disabled:opacity-50 disabled:cursor-not-allowed", {
            'btn-filled-lg': !_ctx.isLoading,
            'btn-filled-lg-loading': _ctx.isLoading,
          }]),
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args))),
          disabled: !_ctx.meta.valid
        }, _hoisted_10, 10, _hoisted_8)
      ])
    ])
  ]))
}